import axios from 'axios'

const token = () => sessionStorage.getItem('token') || ''

const logoRoutes = {
    empresas: {
        build: (id) => {
            const base = `${axios.defaults.baseURL}/empresas/${id}`
            const url = new URL(base)
            url.searchParams.set('logo', '1')
            url.searchParams.set('Authorization', token())
            return url.toString()
        }
    },
    proyectos: {
        build: (id) => {
            const base = `${axios.defaults.baseURL}/proyectos/logo/${id}`
            const url = new URL(base)
            url.searchParams.set('Authorization', token())
            return url.toString()
        }
    },
    cuentas: {
            
        build: id => {
            const url = new URL(`${axios.defaults.baseURL}/cuentas/${id}`)
            url.searchParams.set('logo', '1')
            url.searchParams.set('Authorization', token())
            return url.toString()
        }
    },
    
    subproyectos: {
        build: (id) => {
            const base = `${axios.defaults.baseURL}/subproyectos/logo/${id}`
            const url = new URL(base)
            url.searchParams.set('Authorization', token())
            return url.toString()
        }
  },
  
}

export const cargaLogoUrl = (tipo, id) => {
  const cfg = logoRoutes[tipo]
  return cfg ? cfg.build(id) : undefined
}
